<template>
  <section>
    <div class="step-holder container">
      <div class="columns">
        <div class="column is-10 is-offset-1 stepbar-padding">
          <div class="lc-intro-block">
            <h3 class="intro">Awesome! To help us match you with the best factories, please give us an idea of</h3>
          </div>
          <div class="columns">
            <div class="column">
              <div class="lc-product">
                <LCProductFrontBack :front="form.productThumbnail" :back="form.productThumbnailBack"/>
                <div class="product-title">{{form.productModel}}</div>
                <div class="factories-tip">+50 factories that could build this product</div>
              </div>
            </div>
            <div class="column is-8">
              <form
                @submit.prevent="onSubmit"
              >
                <span class="cost-unit-placeholder">USD$</span>
                <b-field
                  horizontal
                  label="Estimated retail price"
                  class="lc-field"
                >
                  <b-input
                    v-model="form.retailCost"
                    placeholder="enter max value"
                    @input="emitValidate"
                    class="retail-cost"
                  />
                </b-field>
                <b-field
                  label="Tell us what else we should consider about your design"
                  class="lc-field"
                >
                  <b-input
                    v-model="form.comments"
                    type="textarea"
                    placeholder="eg. I‘d like to make a different cut and have a sleeve with a different texture"
                    @input="emitValidate"
                    @keydown.enter.stop.prevent=""
                  />
                </b-field>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import LCProductFrontBack from '@/components/leads_catcher/LCProductFrontBack.vue'

  export default {
    name: 'Comments',
    components: {
      LCProductFrontBack
    },
    props: {
      form: Object
    },
    mounted() {
      this.emitValidate()
    },
    methods: {
      validate() {
        // return true
        return (this.form.retailCost != '' &&
                this.form.comments != '')
      },
      emitValidate() {
        this.$emit('validated', this.validate())
      },
    }
  }
</script>

<style lang="scss" scoped>
  form {
    position: relative;
  }

  .cost-unit-placeholder {
    color: rgba(255, 255, 255, 0.3);
    font-weight: bold;
    position: absolute;
    right: 0px;
    margin-top: 33px;

    @media screen and (min-width: $tablet) {
      right: 20px;
      margin-top: 8px;
    }
  }

  .retail-cost input {
    padding: 25%;
  }

  .lc-product {
    margin-top: -10px;
    margin-bottom: 15px;

    @media screen and (min-width: $tablet) {
      margin-bottom: 0px;
    }

    .image {
      width: 50%;
      margin: 0 auto;

      @media screen and (min-width: $tablet) {
        width: 100%;
      }
    }
  }

  .product-title,
  .factories-tip {
    text-align: center;
    width: 100%;
  }

  .product-title {
    font-size: 14px;
    font-weight: bold;
    color: #FFD1AD;
    margin-top: 10px;

    @media screen and (min-width: $tablet) {
      font-size: 20px;
    }
  }

  .factories-tip {
    font-size: 12px;
    color: rgba(255,255,255,0.8);
  }
</style>
